<div class="tw-flex tw-flex-col tw-h-full tw-bg-teal-300 tw-pb-[calc(112px+24px)] tw-overflow-scroll tw-relative">
  <div class="tw-flex tw-absolute tw-top-15 tw-left-5 tw-items-center tw-justify-center tw-bg-black tw-rounded-xl tw-h-10 tw-w-10" (click)="back()">
    <cs-icon class="tw-h-6 tw-w-6 tw-text-white" [iconName]="'arrow_back'"></cs-icon>
  </div>
  <div class="tw-flex-1 tw-p-6 tw-flex tw-flex-col tw-items-center tw-text-center tw-pt-[84px] tw-gap-3">
    <p class='tw-text-300 tw-font-normal tw-font-lexend tw-uppercase'>👍 <span i18n="@@youreAllSet">You’re all set</span></p>
    <div class="tw-font-lexend tw-font-bold tw-text-gray-800" [class.tw-text-700]="isDravidianScriptUser" [class.tw-text-800]="!isDravidianScriptUser" i18n="@@helpsToKnowYourCity">
      It helps to <br/> know your city
    </div>
  </div>
</div>
<footer class="tw-fixed tw-z-[1001] tw-h-[64%] tw-bottom-0 tw-right-0 tw-left-0 tw-pt-[26px] tw-px-6 tw-flex tw-flex-col tw-items-stretch tw-bg-white tw-rounded-t-5 sm:tw-min-h-[186px]">
  <p class="tw-font-lexend tw-text-300 tw-text-gray-800 tw-mb-6 tw-mt-8" i18n="@@areasClimate">Your area’s climate can be a major factor behind your skin and hair concerns.</p>
  <div class=''>
    <p class='tw-uppercase tw-text-100 tw-font-lexend tw-tracking-wider tw-font-normal tw-mb-3' i18n='@@forEg'>For eg.</p>
    <div class='tw-px-05 tw-mb-10 tw-flex tw-flex-col tw-gap-2' [class.tw-flex-col-reverse]="showHairFirst">
      <div class='tw-w-full tw-rounded-2 tw-bg-gray-100 tw-px-5 tw-py-2 tw-flex tw-items-center tw-justify-start tw-gap-3'>
        <img src='/assets/icons/delhi.svg' class='tw-w-14' />
        <p class='tw-font-lexend tw-text-300' i18n='@@delhiPollution'>Delhi’s pollution is a major factor behind pigmentation</p>
      </div>
      <div class='tw-w-full tw-rounded-2 tw-bg-gray-100 tw-px-5 tw-py-2 tw-flex tw-items-center tw-justify-start tw-gap-3'>
        <img src='/assets/icons/bangalore.svg' class='tw-w-14' />
        <p class='tw-font-lexend tw-text-300' i18n='@@bangaloreHardWater'>Bangalore’s hard water can cause heavy hair fall</p>
      </div>
    </div>
  </div>
  <div class='tw-absolute tw-bottom-6 tw-left-4 tw-right-4'>
    <button csButton
      id="location-btn"
      type="button"
      class="tw-w-full tw-relative proceed"
      [loading]="loading"
      (click)="getLocation()"> <span i18n="@@useMyLocation">Use my location</span>
    </button>
    <button csButton="muted"
      id="continue-btn"
      type="button"
      class="tw-w-full tw-relative proceed"
      [disabled]="loading"
      (click)="continue()"><span i18n="@@skip">Skip</span>
    </button></div>
</footer>
